import type { ISODateTimeString } from '../BrandedTypes'

export const Monetary = {
  CurrencyAdded: 'Monetary.V1.CurrencyAddedToLibrary',
  CurrencyRemoved: 'Monetary.V1.CurrencyRemovedFromLibrary'
} as const

export type CurrencyAddedSignalRPayload = {
  code: string
  name: string
  occuredAt: ISODateTimeString
}

export type CurrencyRemovedSignalRPayload = {
  code: string
  name: string
  occuredAt: ISODateTimeString
}
